import { useKeycloak } from '@react-keycloak/web';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { AppProviders } from '@/app/AppProviders';
import AuthBootstrap from '@/app/ui/AuthBootstrap';
import ErrorBoundary from '@/app/ui/ErrorBoundary';
import UploadProgress from '@/app/ui/UploadProgress';
import { MapProvider } from '@/shared/lib/openlayers/MapContext';
import { FileDialogProvider } from '@/shared/ui/FileDialogContext/FileDialogContext';

import Routes from './Routes';

const App = () => {
  const { initialized } = useKeycloak();

  return (
    <AppProviders>
      {initialized ? (
        <ErrorBoundary>
          <MapProvider>
            <FileDialogProvider>
              <Routes />
            </FileDialogProvider>
          </MapProvider>
        </ErrorBoundary>
      ) : (
        <AuthBootstrap />
      )}
      <UploadProgress />
      {import.meta.env.DEV && <ReactQueryDevtools />}
    </AppProviders>
  );
};

export default App;
